import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { fetchOrganisaties } from '../services/fetchOrganisaties'

export { useOrganisaties, queryKey }

const queryKey = 'organisaties'

const useOrganisaties = () => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data, isFetching } = useQuery({
    queryFn: fetchOrganisaties,
    queryKey: [queryKey],
    enabled: hasPermissions,
  })

  return {
    data: data || [],
    isLoading: isFetching,
  }
}
